import toastr from "toastr";

/**
 * Modal Notification Utility Function
 * Displays a notification using the toastr library.
 *
 * @param {Object} options - Notification options.
 * @param {string} options.type - Type of notification (info, success, error, warning).
 * @param {string} options.message - Message to be displayed in the notification.
 */
const modalNotification = ({ type, message }) => {
  // Mapping of notification types to corresponding icons
  let icon = {
    info: "ni ni-info-fill",
    success: "ni ni-check-circle-fill",
    error: "ni ni-cross-circle-fill",
    warning: "ni ni-alert-fill",
  };

  // Clear any existing toastr notifications
  toastr.clear();

  // Construct the HTML for the toastr notification
  let msg = `<span class="toastr-icon"><em class="icon ${icon[type]}"></em></span><div class="toastr-text">${message}</div>`;
  // Configure toastr options
  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-top-right",
    closeHtml: '<span class="btn-trigger">&#10006;</span>',
    preventDuplicates: true,
    showDuration: "1500",
    hideDuration: "1500",
    timeOut: "2000",
    toastClass: "toastr",
    extendedTimeOut: "5000",
    tapToDismiss: true,
    maxOpened: 1,
  };

  // Display toastr notification based on the specified type

  // eslint-disable-next-line
  toastr[type](msg);
};

export default modalNotification;
